// extracted by mini-css-extract-plugin
export default {"fetching":"PriceBreakdown_fetching__zJMmx"};